import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { API_RESPONSE_LIMITS, ENDPOINTS } from '@app/core/constants/endpoints';
import { Observable } from 'rxjs';
import { AuthenticatedUser } from '@app/shared/models/authenticated-user.model';
import { List } from '@app/shared/models/list.model';
import { map } from 'rxjs/operators';

@Injectable()
export class UserService {
    constructor(private http: HttpClient) {}

    getCompanies(user: AuthenticatedUser): Observable<List<string>> {
        const params = new HttpParams().set('limit', API_RESPONSE_LIMITS.default.toString());

        return this.http.get(`${ENDPOINTS.apis.users.base}/${user.id}/companies`, { params }).pipe(
            map((list: any) => {
                return {
                    start: list.start,
                    limit: list.limit,
                    size: list.size,
                    links: {
                        previous: list.links.previous,
                        next: list.links.next,
                    },
                    items: list.items,
                } as List<string>;
            })
        );
    }
}
